/**
 * Parameterised empty-state for the Overview / Coverage / Quality /
 * Split tabs.
 *
 * Renders the verbatim copy from `feature-spec.md` §2.6 per tab. Used
 * when `collection.status !== 'active'` (no annotation data yet).
 */

import React from 'react';
import { BarChart3 } from 'lucide-react';

interface Props {
  tabName: 'overview' | 'coverage' | 'quality' | 'split';
}

const EmptyTabState: React.FC<Props> = ({ tabName }) => (
  <div
    className="flex flex-col items-center justify-center rounded-lg border-2 border-dashed border-border/70 bg-card/40 px-4 py-16 text-center"
    data-testid={`empty-${tabName}-state`}
  >
    <BarChart3 className="h-10 w-10 text-muted-foreground" aria-hidden="true" />
    <h2 className="mt-3 text-base font-semibold text-foreground">
      No {tabName} data yet
    </h2>
    <p className="mt-2 max-w-md text-[13px] leading-relaxed text-muted-foreground">
      Upload and annotate records to see metrics here.
    </p>
  </div>
);

export default EmptyTabState;
